import api from 'api/api'
import { toast } from 'react-toastify'

export const GET_CASH_REGISTER_MOVEMENTS = '[CASH REGISTER MOVEMENTS] GET CASH REGISTER MOVEMENTS'
export const SAVE_CASH_REGISTER_MOVEMENT = '[CASH REGISTER MOVEMENTS] SAVE CASH REGISTER MOVEMENT'
export const VOID_CASH_REGISTER_MOVEMENT = '[CASH REGISTER MOVEMENTS] VOID CASH REGISTER MOVEMENT'

export function getCashRegisterMovementsAction(cashRegisterId) {
  const request = api.get(`/cash-register-movements/${cashRegisterId}`)
  return (dispatch) => {
    dispatch({ type: GET_CASH_REGISTER_MOVEMENTS, payload: { loading: true } })
    request.then((response) => {
      dispatch({ type: GET_CASH_REGISTER_MOVEMENTS, payload: { data: response.data.data } })
    }).catch((error) => {
      console.log(GET_CASH_REGISTER_MOVEMENTS, error)
    }).finally(() => {
      dispatch({ type: GET_CASH_REGISTER_MOVEMENTS, payload: { loading: false } })
    })
  }
}

export function saveCashRegisterMovementAction(data) {
  const request = api.post('/cash-register-movements/save', data)
  return (dispatch) => {
    dispatch({ type: SAVE_CASH_REGISTER_MOVEMENT, payload: { saving: true } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: SAVE_CASH_REGISTER_MOVEMENT, payload: { saved: true, data: response.data.data } })
      toast.success(response.data.message)
    }).catch((error) => {
      console.log(SAVE_CASH_REGISTER_MOVEMENT, error)
    }).finally(() => {
      dispatch({ type: SAVE_CASH_REGISTER_MOVEMENT, payload: { saving: false } })
    })
  }
}

export function voidCashRegisterMovementAction(cashMovementRegisterId) {
  const request = api.put(`/cash-register-movements/${cashMovementRegisterId}/void`)
  return (dispatch) => {
    dispatch({ type: VOID_CASH_REGISTER_MOVEMENT, payload: { voiding_id: cashMovementRegisterId } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: VOID_CASH_REGISTER_MOVEMENT, payload: { voided_id: cashMovementRegisterId, data: response.data.data } })
      toast.success(response.data.message)
    }).catch((error) => {
      console.log(VOID_CASH_REGISTER_MOVEMENT, error)
    }).finally(() => {
      dispatch({ type: VOID_CASH_REGISTER_MOVEMENT, payload: { voiding_id: cashMovementRegisterId } })
    })
  }
}